import { render, staticRenderFns } from "./AsideSticky.vue?vue&type=template&id=1ec565cc&scoped=true&"
import script from "./AsideSticky.vue?vue&type=script&lang=js&"
export * from "./AsideSticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec565cc",
  null
  
)

export default component.exports